export const LUX_LOYALTY_TIER_DISPLAY_NAMES: Record<App.LuxLoyaltyTier, string> = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
}
